import React from 'react';

import { Map } from 'common/utils/Map/types/map';
import {
  ChargePriceType,
  PriceServiceMapData,
  useBestPriceStationByStationCode,
  usePriceServiceMapData,
} from 'entities/stations';
import { useIntl } from 'react-intl';
import { MapInfoWindow } from 'entities/map';
import { useStyles } from './styles';
import { Typography } from 'e100-react-components';

interface ServicePriceStationProps {
  map: Map | null;
}

const findBestPrice = (services: PriceServiceMapData[]) => {
  const sortServiceStation = [...services]
    .filter(({ services }) => services.length > 0)
    .sort((a, b) => {
      const priceA = a.services[0]?.price?.amount ?? 0;
      const priceB = b.services[0]?.price?.amount ?? 0;

      return priceA - priceB;
    });

  const clusterCoordinate = services[0].coordinates;

  const [bestPriceStation] = sortServiceStation;

  return bestPriceStation ? [{ ...bestPriceStation, coordinates: clusterCoordinate }] : [];
};

export const ServicePriceStation = ({ map }: ServicePriceStationProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const priceServiceMapData = usePriceServiceMapData();
  const bestPriceStationsCode = useBestPriceStationByStationCode();

  if (!priceServiceMapData || priceServiceMapData.length === 0) {
    return null;
  }

  const showData = priceServiceMapData.reduce((acc, services) => {
    const servicesForShow = services.length > 1 ? findBestPrice(services) : services;
    if (servicesForShow.length === 0) {
      return acc;
    }

    servicesForShow.forEach(({ coordinates, services, stationCode }) => {
      const hasBestPriceStation = bestPriceStationsCode(stationCode);
      if (hasBestPriceStation) {
        return;
      }

      acc.push({
        coordinates,
        services,
        stationCode,
      });
    });

    return acc;
  }, []);

  return (
    <>
      {showData.map(({ services, coordinates }) => (
        <MapInfoWindow map={map} coordinates={[coordinates.latitude, coordinates.longitude]}>
          <div className={classes.container}>
            {services.map(({ price, name, priceType }) => (
              <>
                {price && (
                  <Typography variant="caption">
                    {`${name}: `}
                    <b>
                      {price.amount} {price.currency}
                    </b>
                  </Typography>
                )}
                {ChargePriceType.NetExcise === Number(priceType) && !price?.excise && (
                  <Typography variant="caption" color="secondary" gutterBottom>
                    {formatMessage({ id: 'notExistExcisePrice' })}
                  </Typography>
                )}
              </>
            ))}
          </div>
        </MapInfoWindow>
      ))}
    </>
  );
};
